import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import CardContent from '@material-ui/core/CardContent';

import Collapse from '@material-ui/core/Collapse';

import { red } from '@material-ui/core/colors';

import Button from "@material-ui/core/Button/Button";
import Typography from "@material-ui/core/Typography/Typography";
import AddCarReviewForm from "./AddCarReviewForm";
import AddLpReviewForm from "./AddLpReviewForm";

const useStyles = makeStyles((theme) => ({
    root: {
        maxWidth: 345,
    },
    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },
    content: {
        padding: 0
    }
}));

export default function FormCollapse(props) {
    const classes = useStyles();
    const [expanded, setExpanded] = React.useState(props.open);

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            {!expanded ? <Button variant="contained" color="primary" onClick={handleExpandClick}>
                 &#160;Submit Review&#160;
            </Button> : ''}
            <Collapse in={expanded} timeout="auto" unmountOnExit>
                <CardContent className={classes.content}>
                    <Typography variant="h6">{props.isComment ? 'Leave Comment' : 'Submit Review'}</Typography>
                    {props.item && props.item.makeId ?
                        <AddCarReviewForm item={props.item} lp={props.lp} sendRequest={props.sendRequest}
                                          requestError={props.requestError}
                                          isMobile={props.isMobile} isPopup={props.isPopup}/>
                        : <AddLpReviewForm item={props.item} lp={props.lp} sendRequest={props.sendRequest}
                                           requestError={props.requestError}
                                           isMobile={props.isMobile} isPopup={props.isPopup}
                        isComment={props.isComment}/>
                    }
                </CardContent>
            </Collapse>
        </>
    );
}
